import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVersusCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="versus-circle, vs"><path d="M21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M16.5 10.5V9H13.5V12H16.5V15H13.5V13.5" stroke="currentColor" strokeWidth="1.5"/><path d="M10.5 8.25024V12.9999L9.33333 14.9999H8.16667L7 12.9999V8.25024" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVersusCircle;
